export default "__VITE_ASSET__BuljDuCL__"